module.exports = __webpack_public_path__ + "img/BAWS_Staff4_1_1.a4e7672f.png";